import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
export default {
  name: 'view-equipment-details',
  components: {pageheader},
  props: [],
  data () {
    return {
      input: {}
    }
  },
  computed: {
    ...mapGetters(["roles", "token"]),
  },
  mounted () {
// getting input content
this.input = utils.getInputContent("viewEquipmentDetails", this.roles);
console.log(this.$route.params.Details);
  },
  methods: {

  }
}


